import React, { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Sidebardeo() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/deo-dashboard",
    "/class-ix-regular-student",
    "/class-ix-ex-regular-student",
  ].includes(location.pathname);

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li
          className={`nav-item ${
            location.pathname === "/deo-dashboard" ? "active" : ""
          }`}
        >
          <a
            href=""
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/deo-dashboard");
            }}
          >
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </a>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/deo-pending-for-approval" ||
            location.pathname === "/total-pending-applicant"
              ? "active"
              : ""
          }`}
        >
          <a
            href=""
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/deo-pending-for-approval");
            }}
          >
            <i class="fa fa-clock menu-icon"></i>
            <span className="menu-title">Pending for Approval</span>
          </a>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/deo-total-approved" ||
            location.pathname === "/total-approved-applicant"
              ? "active"
              : ""
          }`}
        >
          <a
            href=""
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/deo-total-approved");
            }}
          >
            <i class="fa fa-check menu-icon"></i>
            <span className="menu-title">Total Approved</span>
          </a>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/deo-rejected" ||
            location.pathname === "/total-rejected-applicant"
              ? "active"
              : ""
          }`}
        >
          <a
            href=""
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/deo-rejected");
            }}
          >
            <i class="fa fa-times menu-icon"></i>
            <span className="menu-title">DEO Rejected</span>
          </a>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/total-schools" ||
            location.pathname === "/total-applicant"
              ? "active"
              : ""
          }`}
        >
          <a
            href=""
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/total-schools");
            }}
          >
            <i class="fa fa-university menu-icon"></i>
            <span className="menu-title">Total Schools</span>
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Sidebardeo;
